import request from "@/axios";

/** 从业务字典获取协议名称的接口 */
export const getProtocolNameFromDict = () => {
  return request({
    url: "/lebo-system/dict-biz/dictionary",
    method: "get",
    params: {
      code: "protocol_compliance_name"
    }
  });
};

/** 分页的接口 */
export const getProtocolUpdateList = params => {
  return request({
    url: "/lebo-rabbit/agreement-upgrade-strategy/page",
    method: "get",
    params
  });
};

/** 根据code查询协议相关信息的接口 */
export const getProtocolUpdateInfo = code => {
  return request({
    url: "/lebo-rabbit/agreement-template/by-code",
    method: "get",
    params: {
      code
    }
  });
};

/** 新增升级策略的接口 */
export const addProtocolUpdate = data => {
  return request({
    url: "/lebo-rabbit/agreement-upgrade-strategy",
    method: "post",
    data
  });
};

/** 修改协议升级策略接口 */
export const updateProtocolUpdate = data => {
  return request({
    url: "/lebo-rabbit/agreement-upgrade-strategy",
    method: "put",
    data
  });
};

/** 获取协议升级策略详情的接口 */
export const getProtocolUpdateDetail = id => {
  return request({
    url: `/lebo-rabbit/agreement-upgrade-strategy/${id}`,
    method: "get"
  });
};

/** 获取业务字典中的收端类型 */
export const getProtocolReceiveType = () => {
  return request({
    url: "/lebo-system/dict/dictionary",
    method: "get",
    params: {
      code: "receive_platform"
    }
  });
};

/** 获取业务字典中的发端类型 */
export const getProtocolSendType = () => {
  return request({
    url: "/lebo-system/dict/dictionary",
    method: "get",
    params: {
      code: "send_platform"
    }
  });
};
